module.exports = __webpack_public_path__ + "static/media/Inter-Thin.c485217e.eot";